// @ts-nocheck

import { BetslipByPage, HistoryEntitiesBetslipKeys } from '../constants/history';
import { CommonActionTypes } from '../types/actions/common';
import { HistoryActionTypes } from '../types/actions/history';
import { NetworkActionTypes } from '../types/actions/network';
import { BetslipFilters } from '../types/history';

export const historyInitialState = {
  offset: 0,
  limit: BetslipByPage,
  filter: null,
  type: null,
  startDate: null,
  endDate: null,
  nbBetslips: 0,
  loading: false,
  entities: {
    matches: {},
    bets: {},
    outcomes: {},
    sports: {},
    categories: {},
    tournaments: {},
    missions: {},
    achievements: {},
  },
};

const allowedFilters = [BetslipFilters.RUNNING, BetslipFilters.SETTLED, BetslipFilters.WON];

export default (state = historyInitialState, action) => {
  switch (action.type) {
    case HistoryActionTypes.SET_IS_LOADING: {
      const { isLoading } = action.payload;
      return { ...state, loading: isLoading };
    }
    case NetworkActionTypes.SEND: {
      if ('route' in action.payload && action.payload.route === 'history') {
        return {
          ...state,
          entities: {
            matches: {},
            bets: {},
            outcomes: {},
            sports: {},
            categories: {},
            tournaments: {},
            missions: {},
            achievements: {},
          },
          loading: true,
        };
      }
      return state;
    }
    case CommonActionTypes.RECEIVE_ENTITIES: {
      if ('nbBetslips' in action.payload) {
        const historyEntities = action.payload;

        // filter the history entities by excluding the unused betslip keys
        const filteredHistoryEntities = Object.keys(historyEntities).filter(
          (key) => !HistoryEntitiesBetslipKeys.includes(key),
        );

        // reconstruct the final history entities by using the filtered ones
        const entities = filteredHistoryEntities.reduce((acc, entitie) => {
          acc[entitie] = { ...state.entities[entitie], ...historyEntities[entitie] };
          return acc;
        }, {});

        return {
          ...state,
          entities,
          loading: false,
          nbBetslips: action.payload.nbBetslips,
        };
      }
      return state;
    }
    case HistoryActionTypes.INIT: {
      const { routeParams } = action.payload;
      const filter = parseInt(routeParams.status, 10) || null;
      if (filter && allowedFilters.indexOf(filter) !== -1) {
        return {
          ...state,
          offset: 0,
          filter,
        };
      }
      return state;
    }
    case HistoryActionTypes.SET_FILTER: {
      const page = action.payload.page ?? 0;
      const offset = Math.max(0, page * BetslipByPage);
      const filter = parseInt(action.payload.filter, 10) || null;
      if (filter && allowedFilters.indexOf(filter) !== -1) {
        return {
          ...state,
          offset,
          filter,
        };
      }
      return {
        ...state,
        offset,
        filter,
      };
    }
    case HistoryActionTypes.SET_PERIOD_START:
      return {
        ...state,
        startDate: action.payload.startDate,
      };
    case HistoryActionTypes.SET_PERIOD_END:
      return {
        ...state,
        endDate: action.payload.endDate,
      };
    case HistoryActionTypes.SET_BETSLIP_TYPE:
      return {
        ...state,
        type: action.payload.betslipType,
        offset: 0,
      };
    case HistoryActionTypes.NEXT_OFFSET:
      return {
        ...state,
        offset: Math.max(0, state.offset + BetslipByPage),
      };
    case HistoryActionTypes.PREV_OFFSET:
      return {
        ...state,
        offset: Math.max(0, state.offset - BetslipByPage),
      };
    case HistoryActionTypes.SET_OFFSET: {
      const { page } = action.payload;
      if (typeof page === 'number') {
        return {
          ...state,
          offset: Math.max(0, page * BetslipByPage),
        };
      }
      return state;
    }
    default:
      return state;
  }
};
